export default function LotusMark({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 72 58" aria-hidden="true">
      <g fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
        <path d="M36 50C21 43 16 30 19 18c9 3 15 9 17 18 2-9 8-15 17-18 3 12-2 25-17 32Z" />
        <path d="M36 46C27 35 27 18 36 6c9 12 9 29 0 40Z" />
        <path d="M30 44C17 43 9 36 7 25c10-1 20 5 25 15" />
        <path d="M42 44c13-1 21-8 23-19-10-1-20 5-25 15" />
        <path d="M23 49h26M30 55h12" />
      </g>
    </svg>
  );
}
